module.exports = __webpack_public_path__ + "assets/3627e2ec38b63b3d94c81e5ad408dd8b.json";